import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { Button, FormControl, FormHelperText } from '@material-ui/core';
import { IconButton, InputLabel, useTheme } from '@material-ui/core';
import { MdClose, MdOutlineAddBox } from 'react-icons/md';

import { call } from 'utils';
import CreateTagDialog from './CreateTagDialog';
import AddConditionDialog from '../Channel/shared/UserSelector/AddConditionDialog';

import styles from './TriggerSelector.module.scss';

const TriggerSelector = props => {
  const [dialog, setDialog] = useState({});
  const theme = useTheme();

  const conditions = Array.isArray(props.value) ? props.value : [];
  const { name, error, helperText, disabled, inputProps } = props;
  const { readOnly } = inputProps || {};

  useEffect(() => {
    if (_.isEmpty(dialog)) {
      call(props.onBlur, { target: { name } });
    }
  }, [name, dialog]);

  const update = value =>
    call(props.onChange, {
      type: 'change',
      target: { name, value: _.uniqWith(value, _.isEqual) },
    });

  const onCloseDialog = () => setDialog({});

  const onAddCondition = data => {
    onCloseDialog();

    if (data) {
      update([...conditions, data]);
    }
  };

  return (
    <div className={styles.triggerSelector}>
      <FormControl
        required={props.required}
        fullWidth={props.fullWidth}
        error={error}
        disabled={disabled}
      >
        <InputLabel htmlFor={name} shrink>
          {props.label}
        </InputLabel>

        <div
          className={styles.content}
          style={error ? { borderColor: theme.palette.error.main } : undefined}
        >
          {conditions.length
            ? conditions.map((el, index) => {
                const { category, operator, value } = el;

                return (
                  <div key={index} className={styles.item}>
                    <span>{`${category.text} ${operator} ${value.text}`}</span>

                    {disabled || readOnly ? null : (
                      <IconButton
                        className={styles.button}
                        onClick={() => update(conditions.filter(it => it !== el))}
                      >
                        <MdClose fontSize="medium" />
                      </IconButton>
                    )}
                  </div>
                );
              })
            : null}

          <IconButton
            onClick={() => setDialog({ add: true })}
            style={{ padding: 5, visibility: readOnly ? 'hidden' : 'visible' }}
            disabled={disabled || readOnly}
          >
            <MdOutlineAddBox />
          </IconButton>
        </div>

        <FormHelperText error>{error && helperText ? helperText : ' '}</FormHelperText>
      </FormControl>

      {readOnly ? null : (
        <Button onClick={() => setDialog({ create: true })} disabled={disabled}>
          create tag
        </Button>
      )}

      <AddConditionDialog
        open={!!dialog.add}
        onClose={onCloseDialog}
        onAdd={onAddCondition}
        singleOp
      />

      <CreateTagDialog
        open={!!dialog.create}
        onClose={onCloseDialog}
        onCreate={onAddCondition}
      />
    </div>
  );
};

export default TriggerSelector;
